import Badge from "@common/controls/Badge/component";
import React from "react";
import { type BadgeInfo } from "./types";

type Props = {
  badges: BadgeInfo[];
};

const Badges = (props: Props) => {
  if (!props.badges.length) return null;

  return (
    <div className="filter_badges">
      {props.badges.map((x) => (
        <Badge
          key={x.key}
          className="pointer"
          onClick={x.onClick}
          title={typeof x.valueLabel === "string" ? x.valueLabel : undefined}
        >
          {x.label}: {x.valueLabel}
        </Badge>
      ))}
    </div>
  );
};

export default Badges;
